<template>
    <div class="paperpile_rg_section_wrp">
        <div class="paperpile_content_wrp">
            <div class="paperpile_content_header">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="rfiles_main_heading" v-if="researchGroupDetails"><button type="button"
                                class="btn back_btn" tapable @click="$router.go(-1)">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>{{ researchGroupDetails.name }}
                        </h2>
                    </div>
                    <div class="col-auto">
                        <router-link :to="{ name: 'addPaperPiles' }" class="btn btn-primary">
                            Add Papers
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="paperpile_content_list_wrp mt-4">
                <div class="paperpile_content_list_section" v-if="researchGroupDetails">
                    <ul class="paperpile_content_list_inner" v-if="researchGroupInPapers.length > 0">
                        <li v-for="(item, index) in researchGroupInPapers" :key="item.pdf_paper.id">
                            <label>
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0"><span class="paper_number">{{ index + 1 }}.</span></div>
                                    <div class="col">
                                        <div class="rfiles_list_title">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <h3>{{ item.pdf_paper.title }}</h3>
                                                </div>
                                                <div class="col-auto ml-auto">
                                                    <div class="paper_for_fav_wrp">
                                                        <template v-if="item.pdf_paper.is_favourite">
                                                            <i class="fa fa-star" aria-hidden="true"
                                                                v-on:click="favOfPaperMethod(item.pdf_paper.is_favourite, item.pdf_paper.id)"></i>
                                                        </template>
                                                        <template v-else>
                                                            <i class="fa fa-star-o" aria-hidden="true"
                                                                v-on:click="favOfPaperMethod(item.pdf_paper.is_favourite, item.pdf_paper.id)"></i>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="files_directory_path" v-if="item.pdf_paper.parent_directory">
                                            <h3>../{{ item.pdf_paper.parent_directory }}</h3>
                                        </div>
                                        <div class="rfiles_list_action">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <ul class="rfiles_action_list_wrp">
                                                        <li
                                                            v-on:click="pdfViewerFun(item.pdf_paper.file, item.pdf_paper.file_name, item.pdf_paper.id)">
                                                            Open
                                                        </li>
                                                        <li @click="citationPopupOpenMethod(item.pdf_paper.id)">Cite
                                                        </li>
                                                        <li @click="noteViewShowMethod(item.pdf_paper)"
                                                            v-if="item.pdf_paper && item.pdf_paper.notes.length > 0">My
                                                            Notes</li>
                                                        <!-- <li @click="citationPopupOpenMethod(item.pdf_paper.id)">Cite</li>
                          <li v-on:click="updatePpDetailMethod(item)">Edit</li>
                          <li v-on:click="paperSharedMethod(item)">Share</li>
                          <li @click="paperMoverToFolderMethod(item)">Move</li> -->
                                                    </ul>
                                                </div>
                                                <!-- <div class="col-auto">
                        <i class="fa fa-trash paper_trash_btn" aria-hidden="true"
                          @click="trashPaperMethod(item.pdf_paper.id)"></i>
                      </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </li>
                    </ul>
                    <div class="no_have_papers_text text-center" v-else>Your library is empty. Start building your
                        research collection.
                    </div>
                </div>
            </div>
        </div>
        <pdf-viewer v-if="pdfViewerPopup" v-bind:pdfViewerURL="pdfViewerUrl"
            v-bind:pdfViewerFileNAME="pdfViewerFileName" :pdfID="pdfId"></pdf-viewer>
        <note-read-view :notesViewDATA="notesViewData" v-if="notesViewPopupState"></note-read-view>
        <paper-citation-popup :paperId="citationPaperId" v-if="citationPopupState"></paper-citation-popup>
    </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
    bus
} from '@/main';
import {
    mapGetters,
} from 'vuex';
import noteReadView from '../paper-note-read-view';
import paperCitationPopup from '../paper-citation-popup';
import pdfViewer from '../pdf-viewer';
import ppLeftSidebar from '../paperpile-left-sidebar';
import toast from '@/services/toast';

export default {
    name: 'research-group-list',
    components: {
        'pp-left-sidebar': ppLeftSidebar,
        'pdf-viewer': pdfViewer,
        'note-read-view': noteReadView,
        'paper-citation-popup': paperCitationPopup
    },
    props: [],
    data() {
        return {
            researchGroupDetails: null,
            researchGroupInPapers: [],
            pdfViewerPopup: false,
            pdfViewerUrl: '',
            pdfId: '',
            pdfViewerFileName: '',
            citationPopupState: false,
            citationPaperId: '',
            notesViewPopupState: false,
            notesViewData: null,
            pdf_is_fav: Boolean,
        }
    },
    computed: {
        ...mapGetters([
            'getResearchGroupDetailByIdGetters',
        ]),
        getResearchGroupDetails() {
            this.researchGroupDetails = this.$store.getters.getResearchGroupDetailByIdGetters.data;
            return;
        },
        setInitialsState() {
            if (this.researchGroupDetails) {
                this.researchGroupInPapers = this.researchGroupDetails.pdf_papers
            }
            return;
        }
    },
    mounted() {
        this.getResearchGroupDetails
        this.setInitialsState
        bus.$on('pdfViewerPopupBus', (data) => {
            this.pdfViewerPopup = data;
        });
        bus.$on('paperCitationPopupStateBus', (data) => {
            this.citationPopupState = data;
        });
        bus.$on('notesViewPopupStateBus', (data) => {
            this.notesViewPopupState = data;
        });
    },
    methods: {
        getPapersByIdAgain() {
            this.$store.dispatch('getResearchGroupDetailsByIDFun', { id: this.$route.params.researchGId })
        },
        favOfPaperMethod(isFav, paperId) {
            if (isFav == true) {
                this.pdf_is_fav = false
            } else {
                this.pdf_is_fav = true
            }
            let data = {
                is_favourite: this.pdf_is_fav
            }
            this.$store.dispatch('updatePaperPileDetailsByIdFun', { data: { id: paperId, data: data } })
                .then((res) => {
                    toast.success(res.data.msg);
                    this.getPapersByIdAgain()
                }).catch((err) => {
                    toast.error(err.data.user_msg || err.data.msg);
                })
        },
        citationPopupOpenMethod(Id) {
            this.citationPaperId = Id
            this.citationPopupState = true
            $('body').addClass('body_right_scroll_remove')
        },
        pdfViewerFun(url, fileName, Id) {
            this.pdfId = Id
            this.pdfViewerFileName = fileName
            this.pdfViewerUrl = url
            this.pdfViewerPopup = true
            $('body').addClass("pdf_view_actv")
        },
        noteViewShowMethod(data) {
            this.notesViewData = data
            this.notesViewPopupState = true
            $('body').addClass('body_right_scroll_remove')
        },
    },
    watch: {
        getResearchGroupDetails() {
            return this.$store.getters.researchGroupDetails
        },
        setInitialsState() {
            if (this.researchGroupDetails) {
                this.researchGroupInPapers = this.researchGroupDetails.pdf_papers
            }
            return;
        }
    },
    beforeCreate: function () {
        $('body').addClass('researchfile_body_wrp')
    },
    beforeRouteLeave: function (to, from, next) {
        if (to.name != 'paperPilesPreferences' && to.name != 'paperPiles' && to.name != 'bucketDetails') {
            $('body').removeClass('researchfile_body_wrp');
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
.paperpile_rg_section_wrp {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    height: 100%;

    a {
        text-decoration: none;
    }

    &>.row {
        min-height: calc(100dvh - 80px);
    }

    .paperpile_content_header {
        padding: 0px 15px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        margin: 0 -15px;

        .rfiles_main_heading {
            color: #ffffff;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 0px;
        }

        .rfiles_main_subheading {
            margin: 5px 0px 0px;
            font-size: 18px;
            color: #ffffff;
            line-height: 1;
        }
        .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 95px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: #b41818;
                color: #ffffff;
                border: none;
                border-radius: 3px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 18px;
                letter-spacing: 0.5px;

                @media only screen and (max-width:769px) {
                    font-size: 16px;
                    padding: 6px;
                }

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }
    }
    .paperpile_content_wrp {
        background: rgba(9, 9, 9, 0.95);
        -webkit-box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        border-radius: 5px;
        padding: 15px;
        height: 100%;

        @media only screen and (max-width:769px) {
            min-height: calc(100dvh - 90px);
        }
    }

    .paperpile_content_list_inner {
        margin: 0px;

        &>li {
            background: rgba(255, 255, 255, 0.1);
            padding: 0px;
            border-radius: 5px;
            margin-bottom: 10px;

            label {
                display: block;
                margin: 0px;
                padding: 10px 15px;
            }

            &.label_checked {
                background: rgba(158, 182, 3, 0.15);
            }

            .rfiles_list_title {
                margin-bottom: 0px;

                h3 {
                    font-size: 22px;
                    color: #d6d6d6;
                    margin-bottom: 0px;
                    line-height: 1.2;
                }
            }

            .files_directory_path {
                margin-top: 5px;

                h3 {
                    font-size: 14px;
                    color: #878787;
                    margin: 0;
                    line-height: 1;
                    font-weight: normal;
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                }
            }

            .rfiles_list_action {
                border-top: 1px solid rgba(255, 255, 255, 0.05);
                padding-top: 10px;
                position: relative;
                margin-top: 10px;
            }

            .rfiles_action_list_wrp {
                display: flex;

                li {
                    margin-right: 15px;
                    font-size: 18px;
                    color: #fff8d8;
                    cursor: pointer;

                    &:hover {
                        color: #87cefa;
                    }
                }
            }

            .paper_for_fav_wrp {
                .fa {
                    font-size: 18px;
                    color: #fff8d8;
                    cursor: pointer;
                    line-height: 1.3;

                    &:hover {
                        color: #87cefa;
                    }
                }
            }

            .paper_number {
                font-size: 18px;
                color: #fff8d8;
            }
        }
    }

    .awerack_rg_list_wrp {
        .table {
            margin-bottom: 0;
            letter-spacing: 0.5px;
            color: #ffffff;
            border-collapse: separate;
            border-spacing: 0 3px;

            thead th {
                border-bottom: 0;
                font-size: 19px;
                padding: 10px 8px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                text-transform: uppercase;
                border-top: 0px;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                background: rgba(228, 233, 237, .1);
                color: #87cefa;
            }

            tbody td {
                color: #ffffff;
                vertical-align: top;
                padding: 25px 8px;
                font-size: 20px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border-top: 0px;
                background: rgba(228, 233, 237, .1);
            }

            .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 70px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: rgba(255, 255, 255, 0.12);
                color: #ffd700;
                border: none;
                border-radius: 50px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 16px;
                padding: 6px 0px;
                line-height: 1;

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }
        }
    }

    .users_tooltip_wrp {
        position: relative;
        cursor: pointer;

        .users_tooltip_list {
            right: auto;
            position: absolute;
            background: #ffdee3;
            width: 200px;
            padding: 5px 15px;
            cursor: default;
            z-index: 999;
            border-radius: 0;
            font-weight: 600;
            line-height: 1.4;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 16px;
            color: #000;
            top: calc(100% + 3px);
            border-radius: 2px;
            text-align: left;
            display: none;
            left: -100px;
            z-index: 1000;
            margin: 0px;

            &:before {
                border: solid;
                border-color: #ffdee3 transparent;
                border-width: 12px 12px 0px 0px;
                top: -6px;
                content: "";
                display: block;
                right: auto;
                position: absolute;
                z-index: 1000;
                -webkit-transform: rotate(135deg);
                -moz-transform: rotate(135deg);
                transform: rotate(45deg);
                left: 50%;
            }

            li {
                line-height: 1.1;
                margin-bottom: 3px;

                &:last-child {
                    margin-bottom: 0px;
                }
            }
        }

        &:hover .users_tooltip_list {
            display: block;
        }
    }

    .department_of_research_group {
        color: #fff8d8;
        font-size: 18px;
        display: block;
        line-height: 1.2;
        margin-top: 2px;
    }

    .remove_r_group_popup_wrp {
        position: fixed;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        left: 0;
        right: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;

        .remove_r_group_popup_modal {
            background: #000;
            width: 100%;
            max-width: 500px;
            margin: 0px auto;
            border-radius: 5px;
            padding: 20px 25px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            color: #ffffff;
            -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        }

        .remove_r_group_popup_header h2 {
            font-size: 20px;
            color: #ffffff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            text-align: center;
            margin: 0 0 30px;
        }

        .remove_yes_btn {
            font-size: 16px;
            background: rgba(255, 18, 18, 0.5);
            color: #fff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            padding: 10px 5px;
            min-width: 100px;
            line-height: 1;
            border-radius: 3px !important;
            outline: none !important;
            box-shadow: none !important;

            &:hover {
                background: #ffe738 !important;
                color: #22292f !important;
            }
        }

        .remove_yes_no {
            font-size: 16px;
            background: rgba(33, 228, 0, 0.5);
            color: #fff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            padding: 10px 5px;
            min-width: 100px;
            line-height: 1;
            margin-left: 15px;
            border-radius: 3px !important;
            outline: none !important;
            box-shadow: none !important;

            &:hover {
                background: #ffe738 !important;
                color: #22292f !important;
            }
        }
    }
}

.no_have_papers_text {
    text-align: center;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    font-size: 18px;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.08);
    padding: 50px 15px;
    border-radius: 5px;
    margin-bottom: 10px;
}
</style>